<template>
  <div>
    <title-bar-back :title="'付款结果'" @back="back">
      <div class="title_right"></div>
    </title-bar-back>
    <div class="bg_color">
      <res-det @goHome="goHome" @goOrderDetail="goOrderDetail" />
      <!-- 地址 -->
      <pur-address
        v-if="getUserOrder.address"
        :showGoArrow="false"
        :address="getUserOrder.address"
      />
    </div>
  </div>
</template>

<script>
const TitleBarBack = () =>
  import("@/components/TitleBarBack").then(m => m.default || m);
import ResDet from "./components/ResDet";
import PurAddress from "../purchase/components/PurAddress";
export default {
  name: "OrderResult",
  components: {
    TitleBarBack,
    ResDet,
    PurAddress
  },
  data() {
    return {};
  },
  computed: {
    getUserOrder() {
      return this.$store.getters.getUserOrder;
    }
  },
  created() {
    this.getData();
  },
  methods: {
    // getUserOrder
    // 获取数据
    getData() {
      const params = {
        orderSn: this.$route.query.orderSn
      };
      // console.log(params, "params");
      this.$store
        .dispatch("order/getUserOrder", { params })
        .then(() => {})
        .catch(() => {});
    },
    back() {
      this.$router.back();
    },
    goHome() {
      this.$router.push("/");
    },
    goOrderDetail() {
      this.$router.push({
        path: "/",
        query: {
          orderSn: this.getUserOrder.orderSn
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.title_right {
  width: 36px;
}
.bg_color {
  position: absolute;
  top: 48px;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
}
</style>
